import {
  BEEPER_IMG_PCT,
  getCornerSize,
  getCornerX,
  getCornerY,
  isValidRowCol,
  parseRowColString,
  type KarelEnvironment,
} from '../util';

interface BeepersProps {
  state: KarelEnvironment;
}

export const Beepers = ({state}: BeepersProps) => {
  const beepersData = state.worldState.beepers;
  // do nothing if beepers are not defined
  if (!beepersData) {
    return <></>;
  }
  return (
    <div>
      {Object.keys(beepersData).map(rowColKey => {
        const count = beepersData[rowColKey];
        if (count <= 0) return null;
        const [row, col] = parseRowColString(rowColKey);
        if (!isValidRowCol(state, row, col)) {
          return null;
        }
        return (
          <Beeper r={row} c={col} n={count} state={state} key={rowColKey} />
        );
      })}
    </div>
  );
};

interface BeeperProps {
  r: number;
  c: number;
  n: number;
  state: KarelEnvironment;
}

const Beeper = ({r, c, n, state}: BeeperProps) => {
  const size = BEEPER_IMG_PCT * getCornerSize(state);
  const offset = (getCornerSize(state) - size) / 2;
  const x = getCornerX(state, r, c) + offset;
  const y = getCornerY(state, r, c) + offset;
  const text = n > 1 ? n : '';

  return (
    <div
      className="karel-stone"
      style={{
        width: size,
        height: size,
        marginLeft: x,
        marginTop: y,
      }}
    >
      <div className="karel-stoneDiamond" />
      <span
        className="karel-stoneText"
        style={{
          fontSize: size * 0.75,
          marginTop: -size * 1.05,
          width: size,
        }}
      >
        {text}
      </span>
    </div>
  );
};
